<template>
  <ChartContainer
    :value="current"
    :type="type"
    :lastChart="lastChart"
    :nextChart="nextChart">
    <div class="ry-dashboard__calendar-control">
      <div
        v-if="current && current.hidden === 1"
        class="dashboard-no-permissions__container">
        <i class="iconfont icon-no-permissions"></i>
        <div>暂无权限</div>
      </div>
      <template v-else>
        <div class="data-grid__body">
          <div>
            <el-calendar v-model="currentTime">
              <template
                slot="dateCell"
                slot-scope="{date, data}">
                <p :class="data.isSelected ? 'is-selected' : ''">
                  {{ data.day.split('-')[2] }}
                </p>
                <div v-if="showIndicator(date)"></div>
              </template>
            </el-calendar>
            <el-button
              v-if="false"
              type="text"
              icon="el-icon-plus"
              @click="addForm">
              新建表单
            </el-button>
          </div>
          <div class="calendar-data-container">
            <template v-if="dayData && dayData.length">
              <div
                class="data-item"
                v-for="item in dayData"
                :key="item.key"
                @click="onClickItem(item)">
                <p class="time">{{item.dateData}}</p>
                <div class="user-container">
                  <el-avatar
                    v-for="user in item.memberData.slice(0, 3)"
                    :key="user.userId"
                    icon="el-icon-s-custom"
                    :src="user.headImg"
                    size="small">
                  </el-avatar>
                  <span v-if="item.memberData.length > 3">...</span>
                </div>
                <div class="divider"></div>
                <p class="info-container">{{item.stringData}}</p>
              </div>
            </template>
            <div v-else class="empty-container">
              <p>暂无数据</p>
            </div>
          </div>
        </div>
      </template>
    </div>

  </ChartContainer>
</template>

<script>
  import ChartContainer from './common/container'
  import {FORM_ITEM__DATE, FORM_ITEM__MEMBER, FORM_TYPE__FILL} from "../../RyForm/types";
  import {
    formatDate,
    getCurrentMonthFirstDay,
    getCurrentMonthLastDay,
    startTime
  } from "../../../assets/js/Untis";
  import {SUCCESS} from "../../../src/store/types";
  import FormSet from "../../RyForm";

  export default {
    props: {
      value: Object,
      type: Number,
      nextChart: Function,
      lastChart: Function
    },
    components: {
      ChartContainer
    },
    data() {
      return {
        current: this.value,
        chartHolder: this.value.chartPropertiesHolder,
        loading: false,

        // 表单结构实例
        formSet: null,

        currentTimestamp: new Date(),
        /*
        * {
          dateData: '',
          memberData: [],
          stringData: ''
          }
        * */
        dayData: [],
        formOperateVisible: false,
      }
    },
    created() {
      this.formSet = FormSet.init({
        userId: this.$store.getters.userId,
        companyId: this.$store.getters.currentCompanyId,
        formId: this.current.dataSourceId,
        appId: this.$store.getters.currentAppId
      })
      this.$store.dispatch('actionMergeStructure', {
        appId: this.$store.getters.currentAppId,
        formId: this.current.dataSourceId,
        formType: FORM_TYPE__FILL,
        viewType: 3
      })
        .then(({status, resultObject, info}) => {
          if (status === SUCCESS) {
            return resultObject
          }
        })
        .then(({structureInfo, permissionInfo, detailInfo, widthInfo}) => {
          this.formSet.setStructure(structureInfo)
          this.formSet.setPermission(permissionInfo.permissionList)
          this.formSet.setConf(detailInfo)
          this.formSet.isInit = true
        })
        .catch(err => {
          console.log(err)
        })
    },
    computed: {
      currentTime: {
        set(val) {
          // 判断是否是点击了上个月或下个月
          if (getCurrentMonthFirstDay(this.currentTimestamp) !== getCurrentMonthFirstDay(+val)) {
            this.currentTimestamp = val
            this.current.currentSelectMonth = [getCurrentMonthFirstDay(+val), getCurrentMonthLastDay(+val)]
            this.current.getValue({}, null, true)
              .then(res => {
                this.current.value = res
                this.formatData()
              }).catch(console.error)
          } else {
            this.currentTimestamp = val
            this.formatData()
          }
        },
        get() {
          return this.currentTimestamp
        }
      }
    },
    methods: {
      formatData(timestamp) {
        this.dayData.splice(0, this.dayData.length)
        let now = startTime(+this.currentTimestamp)
        if (timestamp) {
          now = startTime(timestamp)
        }

        const dataList = this.current.value[now]

        if (dataList && dataList.length) {
          let strFieldList = []
          let memberList = []
          this.chartHolder.showFieldIds.forEach(fieldId => {
            let field = this.formSet.fields[fieldId]
            if (field) {
              if (field.type === FORM_ITEM__MEMBER) {
                memberList.push(field)
              } else {
                if (this.chartHolder.dateLatitudeField !== fieldId) {
                  strFieldList.push(field)
                }
              }
            }
          })

          const userList = this.$store.getters.userListMap,
            extList = this.$store.getters.extMap

          dataList.forEach(item => {
            const data = {
              key: Math.random(),
              dateData: formatDate(item[this.chartHolder.dateLatitudeField])('HH:mm'),
              memberData: [],
              stringData: '',
              instanceId: item.instanceId,
              companyId: item.companyId,
              appId: item.appId
            }

            strFieldList.forEach(field => {
              const value = item[field.dataId]
              if (field.valueToString(value)) {
                data.stringData = `${data.stringData}-${field.valueToString(value)}`
              }
            })
            data.stringData = data.stringData.substr(1)

            memberList.forEach(field => {
              console.log(field.dataId, item)
              const value = item[field.dataId]
              if (!value.hasOwnProperty('external')) value.external = []
              const member = [
                ...value.member.map(userId => {
                  return userList[userId] ? {
                    userId: userList[userId].userId,
                    userName: userList[userId].userName,
                    headImg: userList[userId].headImg,
                    type: 'member'
                  } : null
                }),
                ...value.external.map(userId => {
                  return extList[userId] ? {
                    userId: extList[userId].userId,
                    userName: extList[userId].orgUserName,
                    headImg: extList[userId].headImg,
                    type: 'external'
                  } : null
                }),
              ].filter(item => item)

              data.memberData.push(...member)
            })

            this.dayData.push(data)
          })
        }

      },

      // 是否显示红点
      showIndicator(date) {
        if (!this.current.value) {
          return false
        }
        let now = startTime(+date)
        const dataList = this.current.value[now]
        return dataList && dataList.length
      },

      onClickItem(item) {

        let now = startTime(+this.currentTimestamp)

        const dataList = this.current.value[now]

        let index = 0
        for (let i = 0; i < dataList.length; i++) {
          if (dataList[i].instanceId === item.instanceId) {
            index = i
            break
          }
        }
        let fields = null
        if (!this.chartHolder.showAllFields) {
          fields = this.chartHolder.showFieldIds
        }
        if (this.$refs.formDataDetail) {
          this.$refs.formDataDetail.open(item.instanceId, index, dataList, fields)
        }
      },

      addForm() {
        this.formOperateVisible = true
      },


      // 暂存回调
      draftsCallback() {
        this.formOperateVisible = false
      },
      // 丢弃表单回调
      discardCallback() {
        this.$refs.formOperate.getFormData()
      },
      // 提交成功回调
      submitCallback() {
        this.formOperateVisible = false
        this.current.getValue({}, null, true)
          .then(res => {
            this.current.value = res
            this.formatData()
          }).catch(console.error)
      }
    },
    watch: {
      'current.value'() {
        setTimeout(() => {
          this.formatData()
        }, 1000)

      }
    }
  }
</script>

<style rel="stylesheet" lang="less">
  .ry-dashboard__calendar-control {
    width: 100%;
    height: 99%;
    position: relative;

    > .data-grid__body {
      position: absolute;
      top: 0;
      bottom: 0;
      padding: 0 12px;
      left: 0;
      right: 0;

      .el-calendar__body {
        padding: 12px 0 10px;
      }

      .el-calendar__header {
        padding: 20px 5px;
      }

      .el-calendar-table {
        width: auto;

        .current, .next, .prev {
          border: none;
          border-radius: 50%;
          width: 28px;
          height: 28px;

          .el-calendar-day {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            margin: 10px;
            width: 28px;
            height: 28px;
            font-size: 14px;

            p {
              margin: 0;
              word-break: normal;
            }

            > div {
              width: 4px;
              height: 4px;
              border-radius: 50%;
              display: inline-table;
              background-color: #E56833;
            }
          }
        }

        td.is-selected {
          background-color: #fff;

          .el-calendar-day {
            background-color: #F2F8FE;
          }
        }
      }

      .calendar-data-container {
        overflow: auto;
        padding: 10px 5px;
        background: #F3F6FC;
        border-radius: 0 4px 4px 0;
        border-left: 4px solid #D2E6FC;
        margin-bottom: 10px;

        .data-item {
          display: flex;
          align-items: center;
          padding: 10px;
          border: 1px solid #e6e6e6;
          border-radius: 5px;
          cursor: pointer;
          background-color: #fff;
          margin-bottom: 10px;
          width: max-content;
          min-width: 100%;
          height: 54px;

          p {
            margin: 0;
          }

          .time {
            font-size: 16px;
            margin-right: 10px;
          }

          .user-container {
            padding-right: 5px;

            .el-avatar {
              margin-right: 5px;
              cursor: pointer;
              border: 1px solid #e6e6e6;
            }
          }

          .divider {
            width: 1px;
            height: 80%;
            background-color: #e6e6e6;
          }

          .info-container {
            font-size: 14px;
            margin-left: 10px;
            color: #959699;
          }
        }

        .empty-container {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          p {
            font-size: 14px;
            color: #959699;
          }
        }
      }
    }
  }
</style>
